export default "__VITE_ASSET__DF1zsNmN__"